(function () {
  'use strict';

  /*
   * Leoion Custom Add To Cart
   *
   * Responsibilities:
   * - Detect current selected variant
   * - Detect current quantity
   * - Add variant + quantity to Shopify cart
   * - Open EasySlideCart after successful add
   *
   * IMPORTANT:
   * This uses event delegation so it continues working
   * even when Shopify replaces/re-renders the product section.
   */


  /* =========================================================
     GET CURRENT VARIANT
     ========================================================= */

  function getSelectedVariantId() {

    /*
     * Primary method:
     * Shopify product forms normally contain:
     *
     * <input name="id" value="VARIANT_ID">
     */

    var variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (variantInput && variantInput.value) {
      return variantInput.value;
    }


    /*
     * Fallback:
     * Some themes use a select instead.
     */

    var variantSelect = document.querySelector(
      'form[action*="/cart/add"] select[name="id"]'
    );

    if (variantSelect && variantSelect.value) {
      return variantSelect.value;
    }


    return null;
  }


  /* =========================================================
     GET CURRENT QUANTITY
     ========================================================= */

  function getSelectedQuantity() {

    /*
     * First look inside the Shopify product form.
     */

    var quantityInput = document.querySelector(
      'form[action*="/cart/add"] input[name="quantity"]'
    );

    if (quantityInput && quantityInput.value) {

      var quantity = parseInt(
        quantityInput.value,
        10
      );

      if (!isNaN(quantity) && quantity > 0) {
        return quantity;
      }
    }


    /*
     * Fallback:
     * Some themes place the quantity input outside
     * the product form.
     */

    var anyQuantityInput = document.querySelector(
      'input[name="quantity"]'
    );

    if (anyQuantityInput && anyQuantityInput.value) {

      var fallbackQuantity = parseInt(
        anyQuantityInput.value,
        10
      );

      if (
        !isNaN(fallbackQuantity) &&
        fallbackQuantity > 0
      ) {
        return fallbackQuantity;
      }
    }


    /*
     * If no quantity selector is found,
     * default to 1.
     */

    return 1;
  }


  /* =========================================================
     OPEN EASYSLIDECART
     ========================================================= */

function updateCartCount() {

  return fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  })
  .then(function(response) {

    if (!response.ok) {
      throw new Error('Unable to get cart.');
    }

    return response.json();

  })
  .then(function(cart) {

    var count = cart.item_count;

    var cartBubbles = document.querySelectorAll(
      '#cart-icon-bubble .cart-count-bubble'
    );


    /*
     * Update every existing cart count bubble.
     */

    cartBubbles.forEach(function(bubble) {

      bubble.textContent = count;

      /*
       * Shopify hides the bubble when cart is empty.
       */

      if (count > 0) {
        bubble.classList.remove('is-empty');
      }

    });


    /*
     * If Shopify's header does not currently have
     * a bubble, create one.
     */

    if (
      count > 0 &&
      cartBubbles.length === 0
    ) {

      var cartIcon = document.getElementById(
        'cart-icon-bubble'
      );


      if (cartIcon) {

        var bubble = document.createElement('div');

        bubble.className = 'cart-count-bubble';

        bubble.textContent = count;

        cartIcon.appendChild(bubble);

      }

    }


    console.log(
      'Leoion ATC - Cart count updated:',
      count
    );


    return cart;

  });
}


function openEasySlideCart() {

  var cartIcon = document.getElementById(
    'cart-icon-bubble'
  );


  if (cartIcon) {

    cartIcon.click();

    return true;
  }


  console.warn(
    'Leoion ATC: #cart-icon-bubble not found.'
  );


  return false;
}


  /* =========================================================
     RESET BUTTON
     ========================================================= */

  function resetButton(button) {

    if (!button) {
      return;
    }


    button.classList.remove(
      'loading',
      'success',
      'error'
    );


    button.disabled = false;


    /*
     * Check whether the product is actually available.
     *
     * We don't force the button to Sold Out here because
     * Shopify may update availability dynamically.
     */

    button.textContent = 'Add to Cart';
  }


  /* =========================================================
     SHOW ERROR
     ========================================================= */

  function showError(button) {

    if (!button) {
      return;
    }


    button.classList.remove('loading');
    button.classList.add('error');


    button.disabled = false;


    button.textContent = 'Try Again';


    setTimeout(function () {

      resetButton(button);

    }, 2000);
  }


  /* =========================================================
     MAIN ADD TO CART FUNCTION
     ========================================================= */

  function addToCart(button) {

    if (!button) {
      return;
    }


    /*
     * Prevent double-clicks.
     */

    if (
      button.disabled ||
      button.classList.contains('loading')
    ) {
      return;
    }


    /*
     * Get CURRENT variant.
     */

    var variantId = getSelectedVariantId();


    /*
     * Get CURRENT quantity.
     */

    var quantity = getSelectedQuantity();


    console.log(
      'Leoion ATC - Variant:',
      variantId
    );


    console.log(
      'Leoion ATC - Quantity:',
      quantity
    );


    /*
     * No variant found.
     */

    if (!variantId) {

      button.classList.add('error');

      button.textContent = 'Select a Variant';


      setTimeout(function () {

        resetButton(button);

      }, 2000);


      return;
    }


    /*
     * Start loading state.
     */

    button.classList.add('loading');

    button.classList.remove(
      'success',
      'error'
    );


    button.disabled = true;

    button.textContent = 'Adding...';


    /*
     * Add selected variant + quantity to Shopify cart.
     */

    fetch('/cart/add.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({

        id: Number(variantId),

        quantity: quantity

      })

    })


    /*
     * Handle Shopify response.
     */

    .then(function (response) {

      if (!response.ok) {

        return response
          .json()
          .then(function (data) {

            throw data;

          });

      }


      return response.json();

    })


    /*
     * SUCCESS
     */

    .then(function (data) {

  console.log(
    'Leoion ATC - Added to cart:',
    data
  );


  /*
   * Change button state.
   */

  button.classList.remove(
    'loading',
    'error'
  );


  button.classList.add(
    'success'
  );


  button.disabled = false;


  button.textContent = 'Added to Cart';


  /*
   * Notify any theme/app listeners that
   * the cart changed.
   */

  document.dispatchEvent(
    new CustomEvent(
      'cart:updated',
      {
        detail: {
          variantId: variantId,
          quantity: quantity
        }
      }
    )
  );


  /*
   * Update the Shopify cart count.
   *
   * This gets the REAL current cart quantity
   * from /cart.js.
   */

  updateCartCount()
    .catch(function (error) {

      console.warn(
        'Leoion ATC - Could not update cart count:',
        error
      );

    })
    .finally(function () {

      /*
       * Open EasySlideCart after the cart count
       * has had a chance to update.
       */

      setTimeout(function () {

        openEasySlideCart();

      }, 300);

    });


  /*
   * Reset the custom button.
   */

  setTimeout(function () {

    resetButton(button);

  }, 1500);

})


    /*
     * ERROR
     */

    .catch(function (error) {

      console.error(
        'Leoion ATC - Add to cart error:',
        error
      );


      showError(button);

    });

  }


  /* =========================================================
     EVENT DELEGATION
     ========================================================= */

  /*
   * IMPORTANT:
   *
   * We intentionally DO NOT do:
   *
   * document.querySelector('.custom-atc-btn')
   *
   * during initialization.
   *
   * Shopify can replace product sections.
   *
   * Event delegation means the button can be
   * replaced/re-rendered and this still works.
   */

  document.addEventListener(
    'click',
    function (event) {

      var button = event.target.closest(
        '.custom-atc-btn'
      );


      /*
       * Click wasn't on our custom ATC button.
       */

      if (!button) {
        return;
      }


      /*
       * Prevent normal button/form behavior.
       */

      event.preventDefault();

      event.stopPropagation();


      /*
       * Add product to cart.
       */

      addToCart(button);

    },
    false
  );


  console.log(
    'Leoion Custom ATC loaded.'
  );

})();